import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertTriangle, FiClock } = FiIcons;

const UrgencyBanner = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="bg-gradient-to-r from-red-500 to-red-600 text-white py-8"
    >
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-center gap-4 text-center">
          <motion.div
            animate={{ rotate: [0, 10, -10, 0] }}
            transition={{ duration: 2, repeat: Infinity }}
          >
            <SafeIcon icon={FiAlertTriangle} className="text-3xl text-yellow-300" />
          </motion.div>
          <div>
            <h3 className="text-xl md:text-2xl font-bold mb-2">
              ⚠ ATENCIÓN: Cupos Limitados
            </h3>
            <p className="text-red-100 flex items-center gap-2 justify-center">
              200+ cupos vendidos, asegúrate de aprovechar esta oferta por tiempo limitado
              <SafeIcon icon={FiClock} className="text-yellow-300" />
            </p>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default UrgencyBanner;